module.exports = __webpack_public_path__ + "img/chat-mail-active.d5f487cb.svg";